export const InputStyle = {
  marginTop: '8px',
  width: '100%',
  height: '40px',
  fontSize: '14px',
  color: '#4D4D4D',
  fontFamily: 'SF Pro Display',
  borderRadius: '3px',
  letterSpacing: '0.16px',
  position: 'relative',
  '.MuiFormHelperText-root': {
    padding: '0',
    margin: '0',
  },
  '&.Mui-disabled': {
    WebkitTextFillColor: '#dddddd',
    background: '#dddddd',
  },
  '.Mui-disabled': {
    overflow: 'hidden',
    borderColor: '#D0D0D0',
  },
  '.MuiInputBase-input': {
    padding: '10px 12px',
    fontFamily: 'SF Pro Display',
    fontSize: '14px',
    lineHeight: '20px',
  },
  '.MuiInputAdornment-root ': { marginRight: '0' },
};

export const TextAreaStyle = {
  marginTop: '8px',
  width: '100%',
  height: '80px',
  fontSize: '14px',
  color: '#4D4D4D',
  borderRadius: '3px',
  letterSpacing: '0.16px',
  background: 'transparent',
  borderColor: '#BEBFC0',
  boxSizing: 'border-box',
  padding: '10px 12px',
  fontFamily: 'SF Pro Display',
};


export const addModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: '70%', // yoki 90% agar responsiv qilishni xohlasangiz
  maxHeight: '90vh',
  overflowY: 'auto',
  bgcolor: '#fff',
  borderRadius: '8px',
  boxShadow: 24,
  zIndex: 1300, // MUI modallari uchun optimal zIndex
  outline: 'none',
  overflowX: 'hidden',
};

export const dataGridStyle = {
  '&.MuiDataGrid-root': {
    padding: '0 !important',
    border: 'none !important',
    background: '#fff !important',
    borderRadius: '5px',
  },
  '&.MuiDataGrid-root .MuiDataGrid-withBorderColor': {
    border: 'none !important',
  },
  '.MuiDataGrid-row': {
    borderTop: '2px solid #F6F6F9',
    borderBottom: '2px solid #F6F6F9',
    maxHeight: '40px !important',
    minHeight: '40px !important',
    display: 'flex',
    alignItems: 'center',
  },
  '&.MuiDataGrid-root .MuiDataGrid-columnHeaders': {
    background: '#fff !important',
    minHeight: '56px !important',
    maxHeight: '56px !important',
  },
  '&.MuiDataGrid-cellCheckbox': {
    outline: 'none !important',
  },
  '&.MuiDataGrid-root .MuiDataGrid-iconSeparator': {
    display: 'none !important',
  },
  '.MuiDataGrid-columnHeaderTitle': {
    fontSize: '14px !important',
    fontFamily: 'SF Pro Display !important',
    fontWeight: '700 !important',
    color: '#414042',
  },
  ' &.MuiDataGrid-root .MuiDataGrid-withBorderColor': {
    fontSize: '14px !important',
    fontFamily: 'SF Pro Display !important',
    fontWeight: '400 !important',
    color: '#6D6E71 !important',
  },

  '.Mui-selected .MuiSvgIcon-root': {
    fill: '#005AA9 !important',
  },
  '.MuiSvgIcon-root': {
    fill: '#D9D9D9 !important',
  },

  '.MuiDataGrid-columnHeader': {
    fill: '#D9D9D9 !important',
  },

  '.MuiDataGrid-columnHeader .MuiDataGrid-columnHeaderTitleContainerContent .Mui-checked .MuiSvgIcon-root':
    {
      fill: '#005AA9 !important',
    },

  '&.MuiDataGrid-row:hover': {
    borderRadius: '5px !important',
    background: '#FFF !important',
    // boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.10) !important',
    cursor: 'pointer !important',
  },

  '.MuiButtonBase-root:hover': {
    background: 'transparent !important',
  },

  '.MuiDataGrid-footerContainer': {
    marginTop: '0px !important',
    background: '#F6F6F9 !important',
    maxHeight: '30px !important',
    overflow: 'hidden',
    display: 'none',
  },
  '.Mui-disabled': {
    opacity: '0.5 !important',
  },

  '.MuiTablePagination-actions .MuiButtonBase-root .MuiSvgIcon-root': {
    border: '1px solid #005AA9 !important',
    borderRadius: '50px !important',
    fill: '#005AA9 !important',
    fontSize: '18px !important',
    padding: '4px !important',
  },

  '.MuiTablePagination-actions .MuiButtonBase-root  .MuiSvgIcon-root': {
    border: '1px solid #005AA9 !important',
    borderRadius: '50px !important',
    fill: '#005AA9 !important',
    fontSize: '18px !important',
    padding: '4px !important',
  },
};

